"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgNegative(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        d: "M8.98 11.216a.805.805 0 00-.814.798c0 .44.364.797.814.797.449 0 .813-.357.813-.797a.805.805 0 00-.813-.798zm8.679 1.172L11.11 1.227A2.449 2.449 0 008.98 0c-.885 0-1.7.47-2.131 1.227L.34 12.388a2.35 2.35 0 00-.025 2.397A2.45 2.45 0 002.424 16h13.112a2.45 2.45 0 002.138-1.198 2.35 2.35 0 00-.015-2.414zm-1.407 1.595a.817.817 0 01-.716.406H2.424a.817.817 0 01-.716-.406.784.784 0 010-.797L8.215 2.024a.815.815 0 01.724-.434c.305 0 .585.168.724.434l6.548 11.162c.164.243.18.555.04.813v-.016zM8.98 4.838a.805.805 0 00-.814.798v3.189c0 .44.364.797.814.797.449 0 .813-.357.813-.797v-3.19a.805.805 0 00-.813-.797z",
        id: "negative_svg__a"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M11.98 15.216a.805.805 0 00-.814.798c0 .44.364.797.814.797.449 0 .813-.357.813-.797a.805.805 0 00-.813-.798zm8.679 1.172L14.11 5.227A2.449 2.449 0 0011.98 4c-.885 0-1.7.47-2.131 1.227L3.34 16.388a2.35 2.35 0 00-.025 2.397A2.45 2.45 0 005.424 20h13.112a2.45 2.45 0 002.138-1.198 2.35 2.35 0 00-.015-2.414zm-1.407 1.595a.817.817 0 01-.716.406H5.424a.817.817 0 01-.716-.406.784.784 0 010-.797l6.507-11.162a.815.815 0 01.724-.434c.305 0 .585.168.724.434l6.548 11.162c.164.243.18.555.04.813v-.016zM11.98 8.838a.805.805 0 00-.814.798v3.189c0 .44.364.797.814.797.449 0 .813-.357.813-.797v-3.19a.805.805 0 00-.813-.797z",
        fill: "currentColor",
        fillRule: "nonzero"
      }), (0, _jsxRuntime.jsxs)("g", {
        transform: "translate(3 4)",
        children: [(0, _jsxRuntime.jsx)("mask", {
          id: "negative_svg__b",
          fill: "currentColor",
          children: (0, _jsxRuntime.jsx)("use", {
            xlinkHref: "#negative_svg__a"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "currentColor",
          fillRule: "nonzero",
          mask: "url(#negative_svg__b)",
          d: "M-3-4h24v24H-3z"
        })]
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Negative.js.map